import useMediaQuery from '@mui/material/useMediaQuery'
import I18n from 'i18n-js'
import PropTypes from 'prop-types'
import { useState } from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

import breakpoints from '../../../lib/Breakpoints'
import colors from '../../../lib/Colors'
import fonts from '../../../lib/Font'
import Button from '../Button'
import LegacySvg from '../LegacySvg'

const StyledMessageBar = styled.div`
  background-color: ${({ type }) => {
    switch (type) {
      case 'error':
        return colors.red_200
      case 'warning':
        return colors.orange_200
      case 'info':
        return colors.blue_light
      case 'success':
      default:
        return colors.green_200
    }
  }};
  font-family: ${fonts.family.lato};
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-size: 15px;
  color: ${colors.white};
  position: relative;
  padding: 16px;
  padding-right: 30px;
  transition-property: top, opacity;
  transition: all 0.3s ease;
  transition-property: top, opacity, padding, height;
  flex-wrap: wrap;
  @media (min-width: ${breakpoints.tablet}) {
    flex-direction: row;
    padding-right: 80px;
  }
  ${({ isDismissed }) => {
    return isDismissed
      ? 'top: -80px; opacity: 0; padding: 0; height: 0;'
      : 'top: 0; opacity: 1; height: auto;'
  }};
`

const Copy = styled.span`
  margin: 4px 16px;
  text-align: center;
  cursor: default;
  max-width: 75%;
`

const CTA = styled(Link)`
  border: 1px solid ${colors.white};
  border-radius: 4px;
  color: ${colors.white};
  text-decoration: none;
  padding: 8px;
  width: 20%;
  min-width: 200px;
  max-width: 275px;
  text-align: center;
  transition: background 0.2s ease-in-out;
  background: transparent;
  outline: 0;
  &:hover,
  &:active,
  &:focus {
    background: rgba(255, 255, 255, 0.1);
  }
`

const DismissButton = styled(Button)`
  position: absolute;
  right: 16px;
  top: 0;
  bottom: 0;
  color: ${colors.white};
  outline: 0;
  &:hover,
  &:active,
  &:focus {
    color: ${colors.gray_400};
  }
  @media (min-width: ${breakpoints.tablet}) {
    right: 24px;
    left: auto;
    top: 0;
    bottom: 0;
  }
`

const MessageBar = ({ link, linkText, isDismissable, text, type }) => {
  let symbol = 'facebook'
  switch (type) {
    case 'error':
      symbol = 'info_error'
      break
    case 'warning':
      symbol = 'info_notification'
      break
    case 'info':
      symbol = 'info_notification'
      break
    case 'success':
    default:
      symbol = 'info_confirmed'
      break
  }
  const [isDismissed, setIsDismissed] = useState(false)
  const isTablet = useMediaQuery((theme) => theme.breakpoints.down('md'))

  return (
    <StyledMessageBar isDismissed={isDismissed} type={type}>
      {isTablet ? undefined : (
        <LegacySvg
          color={colors.white}
          height={'40px'}
          symbol={symbol}
          width={'40px'}
        />
      )}
      <Copy>{text}</Copy>
      {link && linkText && <CTA to={link}>{linkText}</CTA>}
      {isDismissable && (
        <DismissButton
          buttonStyle={'text'}
          onClick={() => setIsDismissed(true)}
          title={I18n.t('shared.dismiss')}
        >
          X
        </DismissButton>
      )}
    </StyledMessageBar>
  )
}

MessageBar.propTypes = {
  isDismissable: PropTypes.bool,
  link: PropTypes.string,
  linkText: PropTypes.string,
  text: PropTypes.string,
  type: PropTypes.oneOf(['error', 'warning', 'success', 'info']),
}

MessageBar.defaultProps = {}

export default MessageBar
